module.exports = __webpack_public_path__ + "static/media/payment_status_failed.66fa4b1b.svg";